import React from 'react';
import { getCostForAddon } from '../utils';

const REVIEW_LABEL = 'Rush Edit';

const RUSH_EDIT_ICON = 'rushedit';

export default function () {
  return ({
    billingEntityCode,
    addonsCosts,
    includedAddons




  }) => {
    const zeroCost = getCostForAddon({ billingEntityCode, costs: null });
    const cost = includedAddons.includes('RUSH_EDIT') ?
    zeroCost :
    getCostForAddon({ costs: addonsCosts.RUSH_EDIT.costs, billingEntityCode });

    return [
    {
      reviewLabel: REVIEW_LABEL,
      label: 'No',
      value: false,
      suffix: <span>{zeroCost}</span>,
      icon: RUSH_EDIT_ICON,
      cost: zeroCost
    },
    {
      reviewLabel: REVIEW_LABEL,
      label: 'Yes',
      value: true,
      suffix: <span>{cost}</span>,
      suffixDagger: true,
      icon: RUSH_EDIT_ICON,
      cost
    }];

  };
}